import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import Icon from '@mdi/react';
import { Collapse, IconButton } from '@mui/material';
import { labelForWalletCategoryType, ProductCategory, ProductMacroCategory } from 'azshared';
import React, { useCallback, useState } from 'react';
import { useIntl } from 'react-intl';
import { FinancialPositionCategoryTable } from '../financial-positions-category-table/financial-positions-category-table';

interface FinancialPositionsCategoryBoxProps {
  category: ProductCategory;
  macroCategory: ProductMacroCategory;
}

export const FinancialPositionsCategoryBox = (props: FinancialPositionsCategoryBoxProps) => {
  const { category, macroCategory } = props;
  const [open, setOpen] = useState(false);

  const { formatMessage } = useIntl();

  const toggleOpen = useCallback(() => setOpen(!open), [open]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        toggleOpen();
      }
    },
    [toggleOpen]
  );

  return (
    <div className='financial-positions-box'>
      <div className='financial-positions-accordion' onClick={toggleOpen} onKeyDown={handleKeyDown} tabIndex={0}>
        {formatMessage(labelForWalletCategoryType(category.type))}

        <IconButton aria-label='expand row' size='small'>
          <Icon size={1.5} path={open ? mdiChevronUp : mdiChevronDown} color={'#2E6CD1'} />
        </IconButton>
      </div>
      <div className={open ? 'is-expansion-visible' : ''}>
        <Collapse in={open} timeout='auto' unmountOnExit className='financial-positions-accordion-box'>
          <FinancialPositionCategoryTable macroCategoryType={macroCategory?.type} productCategory={category} />
        </Collapse>
      </div>
    </div>
  );
};
